module.exports = __webpack_public_path__ + "static/img/12.4543ad1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/12.png
// module id = 6Mw4
// module chunks = 0